"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsEmail = exports.isEmail = void 0;
const classValidator = __importStar(require("class-validator"));
const punycode_1 = require("punycode/"); // the / forces import from userland instead of the native module
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const IsString_1 = require("./IsString");
async function isEmail(value, args, constraints) {
    const isStringResults = await (0, IsString_1.isString)(value, args, constraints);
    if (isStringResults.pass === false || isStringResults.skipped) {
        return isStringResults;
    }
    const mergedIsEmailOption = {
        isEmailOptions: {
            ignore_max_length: true,
            ...constraints === null || constraints === void 0 ? void 0 : constraints.isEmailOptions,
        },
    };
    //	sanitized value after going through punycode --> unicode
    //	example is xn--5ca is converted to å
    const sanitizedValue = (0, punycode_1.toUnicode)(value);
    if (!classValidator.isEmail(sanitizedValue, mergedIsEmailOption.isEmailOptions)) {
        return { pass: false, message: "should be a valid email" };
    }
    const ASCIIAssentendCharRegex = new RegExp(/[À-ʯḀ-ỿЀ-ӿ]+/);
    if (ASCIIAssentendCharRegex.test(sanitizedValue)) {
        return { pass: false, message: "should be a valid email" };
    }
    return { pass: true };
}
exports.isEmail = isEmail;
/**
 * Validates that the value is a valid email
 * NOTE: Differs from the class-validator version by allowing additional constraints
 */
function IsEmail(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsEmail",
        defaultMessage: "should be a valid email",
        options,
        constraints,
        validateFn: isEmail,
    });
}
exports.IsEmail = IsEmail;
//# sourceMappingURL=IsEmail.js.map